import {createAction} from 'redux-actions';
import {curry} from 'ramda';
import parseContentItem from '@pluto/parse-content-item';
import {setNotificationAction as setNotification} from '@pluto/notification/Redux/NotificationActions';
import {
    getContentItem,
    updateContentItem,
} from '@pluto/rest';

export const CONTENT_ITEM_SET = 'CONTENT_ITEM_SET';
export const CONTENT_ITEM_RESET = 'CONTENT_ITEM_RESET';
export const EDIT_CONTENT_ITEM_SET = 'EDIT_CONTENT_ITEM_SET';

export const setContentItemAction = createAction(CONTENT_ITEM_SET);
export const resetContentItemAction = createAction(CONTENT_ITEM_RESET);
export const editContentItemAction = createAction(EDIT_CONTENT_ITEM_SET);

export const processContentItem = (data: any) => {
    if (data.message)
        return [data.message];
    
    const item = parseContentItem(data);
    return [null, item];
};

export const editContentItem = curry(async (id, editedValues, dispatch) => {
    const {title, summary} = editedValues;
    const body = {
        languageMeta: {
            id: Number(id),
            title,
            summary,
        },
    };
    
    const {data} = await updateContentItem(id, body);
    const [error, result] = processContentItem(data);
    
    if (!error) {
        return dispatch(editContentItemAction(result));
    }
    
    dispatch(setNotification({
        type: 'error',
        text: error,
    }));
});

export const setContentItem = curry(async (id, dispatch) => {
    const {data} = await getContentItem(id);
    const [error, result] = processContentItem(data);
    
    if (!error)
        return dispatch(setContentItemAction(result));
    
    dispatch(setNotification({
        type: 'error',
        text: error,
    }));
});
